const MODEL_PLACEHOLDERS: Record<string, string> = {
    Gemini: 'gemini-2.5-flash',
    Anthropic: 'claude-haiku-4-5-20251001',
};

class AgencyEditPage {
    private providerSelect: HTMLSelectElement;
    private modelInput: HTMLInputElement;
    private keyInput: HTMLInputElement;
    private featureToggles: NodeListOf<HTMLInputElement>;
    private contractAssistantToggle: HTMLInputElement | null;
    private contractAssistantModeSelect: HTMLSelectElement | null;

    constructor() {
        this.providerSelect = document.getElementById('ai-provider-select') as HTMLSelectElement;
        this.modelInput = document.getElementById('ai-model-input') as HTMLInputElement;
        this.keyInput = document.getElementById('ai-api-key-input') as HTMLInputElement;
        this.featureToggles = document.querySelectorAll<HTMLInputElement>('.ai-feature-toggle');
        this.contractAssistantToggle = document.getElementById('ai-contract-assistant-toggle') as HTMLInputElement | null;
        this.contractAssistantModeSelect = document.getElementById('ai-contract-assistant-mode') as HTMLSelectElement | null;

        if (!this.providerSelect) return;

        this.providerSelect.addEventListener('change', () => this.onProviderChange());
        this.onProviderChange();

        this.contractAssistantToggle?.addEventListener('change', () => this.onAssistantToggleChange());

        // Restore persisted value from data attribute (avoids TagHelper selected-in-attribute issue)
        if (this.contractAssistantModeSelect) {
            const current = this.contractAssistantModeSelect.dataset.currentMode;
            if (current) this.contractAssistantModeSelect.value = current;
        }
        this.onAssistantToggleChange();
    }

    private onProviderChange(): void {
        const provider = this.providerSelect.value;
        const hasProvider = provider !== '';

        if (this.modelInput) {
            this.modelInput.disabled = !hasProvider;
            this.modelInput.placeholder = MODEL_PLACEHOLDERS[provider] ?? '';
        }
        if (this.keyInput) {
            this.keyInput.disabled = !hasProvider;
        }
        this.featureToggles.forEach(toggle => {
            toggle.disabled = !hasProvider;
            if (!hasProvider) toggle.checked = false;
        });

        this.onAssistantToggleChange();
    }

    private onAssistantToggleChange(): void {
        if (!this.contractAssistantModeSelect || !this.contractAssistantToggle) return;
        const enabled = this.contractAssistantToggle.checked && !this.contractAssistantToggle.disabled;
        this.contractAssistantModeSelect.disabled = !enabled;
        if (enabled && !this.contractAssistantModeSelect.value) {
            this.contractAssistantModeSelect.value = 'Verify';
        }
    }
}

const w = window as any;
w.BookAndPack ??= {};
w.BookAndPack.Pages ??= {};
w.BookAndPack.Pages.AgencyEdit = AgencyEditPage;
